import moment from "moment";

export const durationFormatHandler = (duration) => {
  const durationObject = moment.duration(duration, "seconds");
  const hours = durationObject.hours();
  const formatHour = hours.toString().length > 1 ? hours.toString() : `0${hours.toString()}`;
  return hours
    ? `${formatHour}:${moment(new Date(duration * 1000)).format("mm:ss")}`
    : moment(new Date(duration * 1000)).format("mm:ss");
};

export const durationFormatHandlerWithHours = (duration) => {
  const durationObject = moment.duration(duration, "seconds");
  const hours = durationObject.hours();
  const formatHour = hours.toString().length > 1 ? hours.toString() : `0${hours.toString()}`;
  return `${formatHour}:${moment(new Date(duration * 1000)).format("mm:ss")}`;
};
